/* Rova footer on every page.
   Desktop: the full footer everywhere. Mobile: the full footer (tap-to-open sections),
   except product pages, which get a short footer (logo, trust line, payment boxes).
   Replaces the GemPages footer where there is one; on pages without one (policies,
   collections, cart) it is added at the end of the page. Kept separate from
   rova-gift-wrap.js (cart code); if that script drew an older footer, this one replaces it. */
(function () {
  if (window.__rovaFooterLoaded) return;
  window.__rovaFooterLoaded = true;

  /* Journals shown in the footer. To add a journal, add a line here (and in the menus in rova-gift-wrap.js). */
  var JOURNALS = [
    { name: "Japan",  url: "/products/japan-travel-journal" },
    { name: "Bali",   url: "/products/bali-travel-journal",   isNew: true },
    { name: "Italy",  url: "/products/italy-travel-journal",  isNew: true },
    { name: "France", url: "/products/france-travel-journal", isNew: true }
  ];
  /* About and Partner with us links in the footer. To add a page, add a line here. */
  var SHOP_URL = "/pages/journals";
  var ABOUT_LINKS = [
    { name: "Our story", url: "/pages/about" },
    { name: "FAQ", url: "/pages/faq" },
    { name: "Contact", url: "/pages/contact-us" },
    { name: "Destination Request", url: "/pages/destination-request" }
  ];
  /* Press page still exists (/pages/press) but is not linked anywhere for now */
  var PARTNER_LINKS = [
    { name: "Creators", url: "/pages/creators" },
    { name: "Stock Rova", url: "/pages/stock-rova" }
  ];
  /* Header "More" dropdown (desktop) and "More" section (phone menu; the phone menu also lists Our story first) */
  var MORE_LINKS = [
    { name: "FAQ", url: "/pages/faq" },
    { name: "Contact", url: "/pages/contact-us" },
    { name: "Creators", url: "/pages/creators" }
  ];
  var OUR_STORY = { name: "Our story", url: "/pages/about" };
  /* Accessories in the Shop dropdown and the phone menu (no journal dot) */
  var ACCESSORIES = { label: "Accessories", url: "/collections/accessories", links: [{ name: "Memory Pouch Kit", url: "/products/memory-pouch-full-kit" }] };
  var TAGLINE = "Your phone will die. Your stories won't.";
  var SOCIAL = { instagram: "https://www.instagram.com/rova.journal/", tiktok: "https://www.tiktok.com/@rova.journal" };
  var LOGO_URL = "https://cdn.shopify.com/s/files/1/0994/5455/0302/files/Rova_logo_3.png";
  var STRIP_URL = "https://cdn.shopify.com/s/files/1/0994/5455/0302/files/black_footer.png";
  var OLD_DESK = '[id*="global_section_635196607893078803"]';
  var OLD_MOB = '[id*="global_section_635195599280407058"]';
  /* plain payment boxes, shown only for methods the store has turned on */
  var PAY_LABELS = [["pi-visa", "VISA"], ["pi-master", "MC"], ["pi-american_express", "AMEX"], ["pi-apple_pay", "Pay"], ["pi-google_pay", "GPay"]];

  /* Journal colors (softer versions of each cover color), shown as small dots next to the journal names
     in the footer, the phone menu and the desktop Journals dropdown. */
  var DOTS = { japan: "#CF8492", bali: "#C1CB7D", italy: "#E6B28A", france: "#7B96BC" };
  function DOT_CSS(scope, size, gap) {
    var c = scope + ' a[href*="-travel-journal"]::before{content:"";display:inline-block;width:' + size + 'px;height:' + size + 'px;box-sizing:border-box;border-radius:50%;margin-right:' + gap + 'px;flex:none;border:2px solid #FBF8F4;background:#FBF8F4}';
    for (var k in DOTS) c += scope + ' a[href*="/' + k + '-travel-journal"]::before{background:' + DOTS[k] + '}';
    return c;
  }

  /* Callout at the bottom of the phone menu. Change the wording here; set SHOW to false after Nov 12 to remove it. */
  var PREORDER = { SHOW: true, line1: "Restocked · Ready to ship", line2: "Small batch &middot; Limited edition drops", url: "/pages/journals" };

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function logoBox(w) {
    /* the logo file has empty space around the word; crop to the word at width w */
    var s = w / 734;
    return '<a href="/" class="rf-logo" aria-label="Rova home" style="width:' + w + 'px;height:' + Math.round(212 * s) + 'px;background-image:url(' + LOGO_URL + ');background-size:' + (1280 * s).toFixed(1) + 'px auto;background-position:-' + (272 * s).toFixed(1) + 'px -' + (294 * s).toFixed(1) + 'px"></a>';
  }
  function socialHtml() {
    var h = "";
    if (SOCIAL.instagram) h += '<a href="' + SOCIAL.instagram + '" target="_blank" rel="noopener" aria-label="Instagram"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r=".8" fill="currentColor"/></svg></a>';
    if (SOCIAL.tiktok) h += '<a href="' + SOCIAL.tiktok + '" target="_blank" rel="noopener" aria-label="TikTok"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M14 3v11.5a3.5 3.5 0 1 1-3.5-3.5"/><path d="M14 3c.5 2.5 2.5 4.5 5 4.5"/></svg></a>';
    return h ? '<div class="rf-soc">' + h + '</div>' : "";
  }

  var CSS =
    '#rova-footer{font-family:"Zalando Sans Expanded",Assistant,sans-serif;color:#FBF8F4;background:#9C8F85}' +
    '#rova-footer a{color:inherit!important;text-decoration:none!important}' +
    '#rova-footer .rf-strip{display:block!important;width:100%;aspect-ratio:48/1;min-height:14px;background:url(' + STRIP_URL + ') center/cover no-repeat;position:relative;z-index:2;box-shadow:0 -2px 6px rgba(43,38,35,.18),0 4px 10px rgba(43,38,35,.35)}' +
    '#rova-footer .rf-logo{display:block;background-repeat:no-repeat}' +
    '#rova-footer .lbl{font-size:11px;font-weight:600;letter-spacing:1.6px;text-transform:uppercase;opacity:.75}' +
    '#rova-footer .tag{font-size:9.5px;font-weight:600;letter-spacing:.6px;color:#F6D6DC;margin-left:7px}' +
    '#rova-footer .rf-pay{display:flex;gap:7px;flex-wrap:wrap}' +
    '#rova-footer .rf-pay span{display:flex;align-items:center;justify-content:center;min-width:36px;height:23px;padding:0 5px;box-sizing:border-box;border-radius:4px;background:#FBF8F4;color:#5E534B;font-family:Arial,Helvetica,sans-serif;font-size:7.5px;font-weight:700;letter-spacing:.3px}' +
    '#rova-footer .rf-soc{display:flex;gap:16px}#rova-footer .rf-soc svg{width:20px;height:20px;display:block}' +
    '#rova-footer .rf-small{font-size:12px;display:flex;gap:18px;align-items:center;opacity:.9}' +
    '#rova-footer .rf-desk{max-width:1320px;margin:0 auto;padding:60px clamp(28px,5vw,80px) 0}' +
    '#rova-footer .rf-top{display:grid;grid-template-columns:1.25fr 1fr 1fr 1fr;gap:48px;padding-bottom:48px;max-width:1240px}' +
    '#rova-footer .rf-col .lbl a{display:inline;font-size:inherit;margin:0;width:auto}' +
    '#rova-footer .rf-brand p{font-size:14px;line-height:1.55;margin:16px 0 22px;opacity:.9;max-width:300px}' +
    '#rova-footer .rf-col .lbl{margin-bottom:18px}' +
    '#rova-footer .rf-col a{display:flex;align-items:center;font-size:16px;margin-bottom:13px;width:max-content}' +
    '#rova-footer .rf-desk .rf-pay span{min-width:40px;height:26px;font-size:8.5px}' +
    DOT_CSS("#rova-footer .rf-col", 11, 11) + DOT_CSS("#rova-footer .rf-acc-b", 12, 12) +
    '#rova-footer .rf-col a:hover,#rova-footer .rf-small a:hover{text-decoration:underline!important;text-underline-offset:4px}' +
    '#rova-footer .rf-bot{display:flex;justify-content:space-between;align-items:center;border-top:1px solid rgba(251,248,244,.3);padding:20px 0 28px}' +
    '#rova-footer .rf-mob{display:none;padding:32px 24px 30px}' +
    '#rova-footer .rf-mob p{font-size:14px;line-height:1.55;margin:14px 0 18px;opacity:.9}' +
    '#rova-footer .rf-mob .rf-soc{margin-bottom:22px}' +
    '#rova-footer .rf-acc{border-top:1px solid rgba(251,248,244,.3)}' +
    '#rova-footer .rf-acc:last-of-type{border-bottom:1px solid rgba(251,248,244,.3)}' +
    '#rova-footer .rf-acc summary{list-style:none;display:flex;justify-content:space-between;align-items:center;padding:17px 0;cursor:pointer}' +
    '#rova-footer .rf-acc summary::-webkit-details-marker{display:none}' +
    '#rova-footer .rf-acc summary svg{width:12px;height:8px;transition:transform .2s ease}' +
    '#rova-footer .rf-acc[open] summary svg{transform:rotate(180deg)}' +
    '#rova-footer .rf-acc .rf-acc-b{padding:0 0 12px}' +
    '#rova-footer .rf-acc .rf-acc-b a{display:flex;align-items:center;font-size:16px;padding:7px 0}' +
    '#rova-footer .rf-mob .rf-pay{margin:26px 0 14px}' +
    '#rova-footer .rf-mob .rf-small{flex-wrap:wrap;font-size:12px}' +
    '#rova-footer .rf-min{display:none;text-align:center;padding:44px 24px 30px}' +
    '#rova-footer .rf-min .rf-logo{margin:0 auto 24px}' +
    '#rova-footer .rf-min .lbl{margin-bottom:16px}' +
    '#rova-footer .rf-min .rf-pay,#rova-footer .rf-min .rf-small{justify-content:center}' +
    '#rova-footer .rf-min .rf-pay{margin-bottom:14px}' +
    '@media (max-width:989px){#rova-footer .rf-desk{display:none}#rova-footer .rf-mob{display:block}#rova-footer.rf-product .rf-mob{display:none}#rova-footer.rf-product .rf-min{display:block}}' +
    'html.rova-has-footer ' + OLD_DESK + ',html.rova-has-footer ' + OLD_MOB + '{display:none!important}';

  /* keep the last line clear of sticky bars at the bottom of the screen (e.g. "Buy Now") */
  var fixedEls = [], lastScan = 0, padMax = 0;
  function scanFixed(f) {
    fixedEls = [];
    var all = document.body.getElementsByTagName("*");
    for (var i = 0; i < all.length; i++) {
      var e = all[i];
      if (f.contains(e) || e.id === "rova-cart-fab" || e.id === "upCart" || e.id === "PBarNextFrameWrapper") continue;
      if (getComputedStyle(e).position === "fixed") fixedEls.push(e);
    }
    lastScan = Date.now();
  }
  function padForStickyBars(retry) {
    var f = document.getElementById("rova-footer"); if (!f) return;
    if (Date.now() - lastScan > 4000) scanFixed(f);
    var h = 0;
    fixedEls.forEach(function (e) {
      if (!e.isConnected) return;
      var cs = getComputedStyle(e);
      if (cs.display === "none" || cs.visibility === "hidden" || cs.opacity === "0") return;
      var r = e.getBoundingClientRect();
      if (r.height > 0 && r.height < 200 && r.width > window.innerWidth * 0.6 && r.bottom >= window.innerHeight - 2 && r.top > window.innerHeight / 2) h = Math.max(h, window.innerHeight - r.top);
    });
    /* a bar can switch to "fixed" only after scrolling starts: look again if none was found */
    if (!h && !padMax && !retry && Date.now() - lastScan > 1000) { scanFixed(f); return padForStickyBars(true); }
    /* only ever grows, so the page does not jump when a bar slides away */
    if (h > padMax) { padMax = h; f.style.paddingBottom = Math.ceil(h + 8) + "px"; }
  }
  var padTick = false;
  function schedulePad() { if (padTick) return; padTick = true; setTimeout(function () { padTick = false; padForStickyBars(); setTimeout(padForStickyBars, 1200); }, 250); }

  /* short mobile footer for product pages: nothing that pulls shoppers away */
  function shortMobileHtml(pay, year) {
    return '<div class="rf-min">' + logoBox(110) + '<div class="lbl">Small batch &middot; Packed by hand</div>' +
      '<div class="rf-pay">' + pay + '</div>' +
      '<div class="rf-small"><span>&copy; ' + year + " Rova</span></div></div>";
  }

  /* Short pages (an empty cart, say): the theme stretches whatever sits third on the page to fill the
     screen, which left a blank white band under the footer. Stretch the main content instead and keep
     the footer at the bottom of it. */
  function fillShortPage(main) {
    var body = document.body;
    if (main.parentNode !== body || getComputedStyle(body).display !== "grid") return;
    var rows = [], idx = -1;
    Array.prototype.forEach.call(body.children, function (el) {
      var cs = getComputedStyle(el);
      if (cs.display === "none" || cs.position === "fixed" || cs.position === "absolute" || el.tagName === "SCRIPT" || el.tagName === "STYLE") return;
      if (el === main) idx = rows.length;
      rows.push("auto");
    });
    if (idx < 0) return;
    rows[idx] = "1fr";
    body.style.gridTemplateRows = rows.join(" ");
    main.style.display = "flex";
    main.style.flexDirection = "column";
    document.getElementById("rova-footer").style.marginTop = "auto";
  }

  /* old GemPages banner pieces on the product pages (Japan, Italy, Bali, France), plus any other
     section that is just one picture and no words */
  var DECOR_IDS = ["635199450876216070", "639424281993806770", "639429799047070281", "639429072090301001"];
  function isDecor(el) {
    if (el.id === "rova-footer" || el.matches(OLD_DESK)) return false;
    for (var i = 0; i < DECOR_IDS.length; i++) if (el.id.indexOf(DECOR_IDS[i]) > -1) return true;
    var imgs = el.querySelectorAll("img").length;
    if (imgs !== 1) return false;
    var c = el.cloneNode(true);
    c.querySelectorAll("style,script,noscript,template").forEach(function (x) { x.remove(); });
    return !c.textContent.trim();
  }

  function build() {
    var oldDesk = document.querySelector(OLD_DESK);
    var main = document.getElementById("MainContent") || document.querySelector("main");
    if (!oldDesk && !main) return;
    var isProduct = /^\/products\//.test(location.pathname);
    var mine = document.getElementById("rova-footer");
    if (mine && mine.getAttribute("data-v") === "3") return;
    fetch(location.pathname + "?section_id=rova-footer-data", { credentials: "same-origin" })
      .then(function (r) { return r.text(); })
      .catch(function () { return ""; })
      .then(function (html) {
        var cur = document.getElementById("rova-footer");
        if (cur && cur.getAttribute("data-v") === "3") return;
        var tmp = document.createElement("div"); tmp.innerHTML = html;
        var data = tmp.querySelector("#rova-footer-data");
        var enabled = {};
        if (data) data.querySelectorAll("svg").forEach(function (s) { enabled[s.getAttribute("aria-labelledby")] = true; });
        var pay = "";
        PAY_LABELS.forEach(function (p) { if (!data || enabled[p[0]]) pay += "<span>" + p[1] + "</span>"; });
        var privacy = (data && data.getAttribute("data-privacy")) || "/policies/privacy-policy";
        var year = (data && data.getAttribute("data-year")) || new Date().getFullYear();

        /* drop an older footer (and its styles) if the cart script already drew one */
        if (cur) cur.remove();
        var oldStyle = document.getElementById("rova-footer-style"); if (oldStyle) oldStyle.remove();
        if (!document.getElementById("rova-footer-v2-style")) {
          var st = document.createElement("style"); st.id = "rova-footer-v2-style"; st.textContent = CSS; document.head.appendChild(st);
        }

        var chev = '<svg viewBox="0 0 12 8" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M1 1.5l5 5 5-5"/></svg>';
        function acc(label, links, open) { return '<details class="rf-acc"' + (open ? " open" : "") + '><summary><span class="lbl">' + label + "</span>" + chev + '</summary><div class="rf-acc-b">' + links + "</div></details>"; }
        var jLinks = JOURNALS.map(function (j) { return '<a href="' + j.url + '">' + j.name + (j.isNew ? '<span class="tag">NEW</span>' : "") + "</a>"; }).join("");
        function links(list) { return list.map(function (l) { return '<a href="' + l.url + '">' + l.name + "</a>"; }).join(""); }
        function isDR(l) { return /destination-request/.test(l.url); }
        var about = links(ABOUT_LINKS), partner = links(PARTNER_LINKS);
        /* phone footer: Destination Request sits right under France, so About leaves it out */
        var aboutMob = links(ABOUT_LINKS.filter(function (l) { return !isDR(l); })), drMob = links(ABOUT_LINKS.filter(isDR));
        var small = '<div class="rf-small"><a href="' + privacy + '">Privacy</a><span>&copy; ' + year + " Rova</span></div>";

        var f = document.createElement("footer");
        f.id = "rova-footer"; f.setAttribute("data-v", "3");
        if (isProduct) f.className = "rf-product";
        f.innerHTML =
          '<div class="rf-strip"></div>' +
          '<div class="rf-desk"><div class="rf-top">' +
            '<div class="rf-brand">' + logoBox(150) + "<p>" + esc(TAGLINE).replace(". ", ".<br>") + "</p>" + socialHtml() + "</div>" +
            '<div class="rf-col"><div class="lbl"><a href="' + SHOP_URL + '">Journals</a></div>' + jLinks + "</div>" +
            '<div class="rf-col"><div class="lbl">About</div>' + about + "</div>" +
            '<div class="rf-col"><div class="lbl">Partner with us</div>' + partner + "</div>" +
          '</div><div class="rf-bot">' + small + '<div class="rf-pay">' + pay + "</div></div></div>" +
          (isProduct ? shortMobileHtml(pay, year) :
          '<div class="rf-mob">' + logoBox(120) + "<p>" + esc(TAGLINE) + "</p>" + socialHtml() +
            acc("Journals", '<a href="' + SHOP_URL + '">All journals</a>' + jLinks + drMob, true) + acc("About", aboutMob, false) + acc("Partner with us", partner, false) +
            '<div class="rf-pay">' + pay + "</div>" + small +
          "</div>");

        if (oldDesk) {
          oldDesk.parentNode.insertBefore(f, oldDesk);
          /* hide the old decorative banner sections right next to the footer (one image, no text);
             they would double the banner and leave big empty bands around the footer */
          for (var p = f.previousElementSibling; p && isDecor(p); p = p.previousElementSibling) p.style.setProperty("display", "none", "important");
          for (var n = oldDesk.nextElementSibling; n; n = n.nextElementSibling) {
            if (isDecor(n)) n.style.setProperty("display", "none", "important");
          }
        } else {
          /* pages without a GemPages footer (policies, collections, cart): add it at the end */
          main.appendChild(f);
          fillShortPage(main);
          setTimeout(function () { fillShortPage(main); }, 2500);
        }
        document.documentElement.classList.add("rova-has-footer");
        padForStickyBars(); window.addEventListener("scroll", schedulePad, { passive: true }); window.addEventListener("resize", schedulePad); setTimeout(padForStickyBars, 2000);
      });
  }

  /* Phone menu (drawn by rova-gift-wrap.js): restyled here to match the footer — taupe background,
     light logo, tagline, social icons, journal dots and the pre-order callout. Only looks change; the links come
     from the menu itself. */
  var M = ".rova-mobile-nav .rova-menu-drawer";  /* extra-specific so these win even if the menu's own styles load later */
  var MENU_CSS =
    M + '{background:linear-gradient(180deg,#A39689 0%,#9C8F85 45%,#928577 100%)!important;-webkit-backdrop-filter:none!important;backdrop-filter:none!important;padding:28px 28px 30px!important;overflow-y:auto;display:flex!important;flex-direction:column;transition:transform .3s ease!important}' +
    M + '>*{flex-shrink:0}' +
    /* soft shadow on the menu's edge; the page behind is dimmed by a separate layer that only fades (see syncDim) */
    M + '.is-open{box-shadow:-20px 0 44px rgba(20,15,10,.35)!important}' +
    '#rova-menu-dim{display:block!important;position:fixed;inset:0;background:rgba(30,24,20,.42);opacity:0;visibility:hidden;pointer-events:none;transition:opacity .3s ease,visibility 0s linear .3s;z-index:100000}' +
    '#rova-menu-dim.on{opacity:1;visibility:visible;transition:opacity .3s ease,visibility 0s}' +
    M + ' .rova-menu-close{color:#FBF8F4!important}' +
    M + ' .rm-head{margin-top:14px;color:#FBF8F4}' +
    M + ' .rm-head .rf-logo{display:block;background-repeat:no-repeat}' +
    M + ' .rm-head p{font-family:"Zalando Sans Expanded",Assistant,sans-serif;font-size:14px;line-height:1.55;color:#FBF8F4!important;opacity:.9;margin:14px 0 0}' +
    M + ' .rm-head .rf-soc{display:flex;gap:16px;margin-top:18px}' + M + ' .rm-head .rf-soc a{color:#FBF8F4!important;display:block;border:0!important;padding:0!important}' + M + ' .rm-head .rf-soc svg{width:20px;height:20px;display:block}' +
    M + ' .rova-menu-links{margin-top:30px!important;border-top:1px solid rgba(251,248,244,.3)!important;padding-top:22px}' +
    M + ' .rova-menu-links .lbl{color:rgba(251,248,244,.75)!important;opacity:1;padding:0 0 8px!important}' +
    M + ' .rova-menu-links .lbl2{margin-top:18px!important;padding-top:22px!important;border-top:1px solid rgba(251,248,244,.3)!important}' +
    M + ' .rova-menu-links a,' + M + ' .rova-menu-links a:first-child,' + M + ' .rova-menu-links a:last-child{border:0!important;justify-content:flex-start!important;align-items:center!important;padding:9px 0!important;font-weight:400!important;color:#FBF8F4!important}' +
    M + ' .rova-menu-links .j a{font-size:18px!important}' +
    M + ' .rova-menu-links .lbl a.lbl-link{display:inline!important;padding:0!important;font-size:inherit!important;font-weight:inherit!important;letter-spacing:inherit;color:inherit!important;text-decoration:none!important}' +
    M + ' .rova-menu-links .i a{font-size:16px!important}' +
    M + ' .rova-menu-links .rm-acc-l{margin-top:22px!important}' +
    M + ' .rova-menu-links .i.rm-acc a{font-size:18px!important}' +
    M + ' .rova-menu-links details.macc>summary{list-style:none;display:flex;justify-content:space-between;align-items:center;cursor:pointer}' +
    M + ' .rova-menu-links details.macc>summary::-webkit-details-marker{display:none}' +
    M + ' .rova-menu-links details.macc .pm{width:12px;height:12px;flex:none}' + M + ' .rova-menu-links details.macc[open] .pm .v{display:none}' +
    M + ' .rova-menu-links .arr{margin-left:8px}' + M + ' .rova-menu-links .arr svg{display:none!important}' +
    M + ' .rova-menu-links .tag{color:#F6D6DC!important;font-size:9.5px!important}' +
    DOT_CSS(M + " .rova-menu-links .j", 12, 14) +
    /* pre-order callout */
    M + ' .rm-foot{display:block!important;margin-top:auto;padding-top:28px}' +
    M + ' .rm-foot a.rm-pill{display:flex!important;flex-direction:column;align-items:center;justify-content:center;gap:3px;box-sizing:border-box;width:calc(100% + 24px);max-width:none!important;margin:0 -12px!important;padding:20px 10px 19px!important;border:0!important;border-radius:32px;background:#FBF8F4;color:#41372D!important;text-decoration:none!important;box-shadow:0 6px 16px rgba(30,24,20,.18);font-family:"Zalando Sans Expanded",Assistant,sans-serif;line-height:1.2}' +
    M + ' .rm-p1{display:block!important;text-transform:uppercase;font-size:clamp(10px,3.2vw,12px);font-weight:700;letter-spacing:.8px;white-space:nowrap}' +
    M + ' .rm-p2{display:block!important;font-size:clamp(10px,3.07vw,11.5px);font-weight:400;letter-spacing:.2px;color:#6B5F55;white-space:nowrap}';

  /* Desktop "Shop" and "More" dropdowns (drawn by rova-gift-wrap.js): cream, a thin taupe edge on top, one JOURNALS
     label instead of Asia / Europe Edition, the journal dots, and an ACCESSORIES label under the journals. */
  var D = "html #rova-dnav";
  var DNAV_CSS =
    D + ' .dd::after{content:"";position:absolute;left:-20px;right:-20px;top:100%;height:16px}' +  /* keeps the dropdown open while the mouse crosses the gap */
    D + ' .menu{top:calc(100% + 10px)!important;background:#FBF8F4!important;border-top:3px solid #9C8F85!important;border-radius:10px!important;padding:16px 0 12px!important;min-width:230px!important;box-shadow:0 14px 34px rgba(43,38,35,.2)!important}' +
    D + ' .menu .mlbl,' + D + ' .menu a.mlbl{display:block!important;padding:0 24px 8px!important;font-family:"Zalando Sans Expanded",Assistant,sans-serif;font-size:11px!important;font-weight:600;letter-spacing:1.6px;text-transform:uppercase;color:#8F8076!important;background:none!important}' +
    D + ' .menu a.mlbl:hover{background:none!important}' +
    D + ' .menu a.mlbl.acc-l{margin-top:12px!important}' +
    D + ' .menu .lbl{display:none!important}' +
    D + ' .dd>a.ddt{display:inline-flex;align-items:center}' + D + ' .dd>a.ddt svg{flex:none;width:10px;height:10px;margin-left:8px}' +
    D + ' .dd:hover>.ddt:after{transform:scaleX(1)}' +
    D + ' .dd-more .menu{left:auto!important;right:-20px}' +
    D + ' .menu a{justify-content:flex-start!important;align-items:center!important;padding:10px 24px!important;font-size:15px!important;color:#2B2623!important}' +
    D + ' .menu a:hover{background:#F2ECE5!important}' +
    D + ' .menu .tag{margin-left:8px;color:#BB5B6C!important;font-size:10px!important}' +
    DOT_CSS(D + " .menu", 13, 12) +
    D + ' .menu a[href*="-travel-journal"]::before{border-color:#fff;box-shadow:0 0 0 1px rgba(65,55,45,.2)}';

  /* Menu links (header dropdowns and phone menu). rova-gift-wrap.js draws the menus; these lines reshape them:
     Header: "Shop" (journals, then Accessories) and Destination Request on the left; "More" dropdown and Our story
     on the right. Phone menu: Journals, Destination Request, Accessories, then a "More" section that starts closed.
     To change the links, edit MORE_LINKS / ACCESSORIES at the top. */
  var CHEV = '<svg viewBox="0 0 10 6" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M1 1l4 4 4-4"/></svg>';
  var PLUS = '<svg class="pm" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M1 6h10"/><path class="v" d="M6 1v10"/></svg>';
  function linkList(list) { return list.map(function (l) { return '<a href="' + l.url + '">' + l.name + "</a>"; }).join(""); }
  function patchDesktopNav() {
    var n = document.getElementById("rova-dnav");
    if (!n || n.getAttribute("data-menus") === "3") return;
    var shop = n.querySelector(".dd"), grps = n.querySelectorAll(".grp"), cart = n.querySelector(".rova-nav-cart");
    if (!shop || grps.length < 2 || !cart) return;
    var t = shop.querySelector(":scope > span");
    if (t) { var a = document.createElement("a"); a.href = SHOP_URL; a.className = "ddt"; a.innerHTML = "Shop" + CHEV; t.parentNode.replaceChild(a, t); }
    var menu = shop.querySelector(".menu");
    if (menu && !menu.querySelector(".mlbl")) menu.insertAdjacentHTML("afterbegin", '<a href="' + SHOP_URL + '" class="mlbl">Journals</a>');
    if (menu && !menu.querySelector(".acc-l")) menu.insertAdjacentHTML("beforeend", '<a href="' + ACCESSORIES.url + '" class="mlbl acc-l">' + ACCESSORIES.label + "</a>" + linkList(ACCESSORIES.links));
    var right = grps[1];
    Array.prototype.slice.call(right.children).forEach(function (el) { if (el !== cart) el.remove(); });
    cart.insertAdjacentHTML("beforebegin",
      '<div class="dd dd-more"><span tabindex="0" class="ddt">More' + CHEV + '</span><div class="menu"><div class="mlbl">More</div>' + linkList(MORE_LINKS) + "</div></div>" +
      '<a href="' + OUR_STORY.url + '">' + OUR_STORY.name + "</a>");
    n.setAttribute("data-menus", "3");
  }
  function patchMobileNav() {
    var links = document.querySelector(".rova-mobile-nav .rova-menu-links.rova-mnav");
    if (!links || links.getAttribute("data-menus") === "3") return;
    var first = links.querySelector(".lbl");
    if (first && !first.querySelector("a")) first.innerHTML = '<a href="' + SHOP_URL + '" class="lbl-link">Journals</a>';
    Array.prototype.slice.call(links.children).forEach(function (el) { if (el.classList.contains("lbl2") || el.classList.contains("i") || el.tagName === "DETAILS" || el.classList.contains("rm-acc-l")) el.remove(); });
    function sec(label, list) { return '<details class="macc"><summary class="lbl lbl2">' + label + PLUS + '</summary><div class="i">' + linkList(list) + "</div></details>"; }
    var dr = ABOUT_LINKS.filter(function (l) { return /destination-request/.test(l.url); });
    var j = links.querySelector(".j");
    var mid = (dr.length ? '<div class="i rm-dr">' + linkList(dr) + "</div>" : "") +
      '<div class="lbl rm-acc-l"><a href="' + ACCESSORIES.url + '" class="lbl-link">' + ACCESSORIES.label + "</a></div>" +
      '<div class="i rm-acc">' + linkList(ACCESSORIES.links) + "</div>";
    if (j) j.insertAdjacentHTML("afterend", mid);
    links.insertAdjacentHTML("beforeend", sec("More", [OUR_STORY].concat(MORE_LINKS)));
    links.setAttribute("data-menus", "3");
  }
  function patchMenus() { patchDesktopNav(); patchMobileNav(); }
  function watchMenus() {
    patchMenus();
    if (!window.MutationObserver) return;
    var mo = new MutationObserver(patchMenus);
    mo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); patchMenus(); }, 15000);
  }

  function styleMenu() {
    if (!document.getElementById("rova-menu-style")) {
      var st = document.createElement("style"); st.id = "rova-menu-style"; st.textContent = MENU_CSS + DNAV_CSS; document.head.appendChild(st);
    }
    var d = document.querySelector(".rova-menu-drawer");
    if (!d) return;
    if (!d.querySelector(".rm-head")) {
      var h = document.createElement("div");
      h.className = "rm-head";
      h.innerHTML = logoBox(120) + "<p>" + esc(TAGLINE) + "</p>" + socialHtml();
      var nav = d.querySelector("nav");
      if (nav) d.insertBefore(h, nav); else d.appendChild(h);
    }
    if (PREORDER.SHOW && !d.querySelector(".rm-foot")) {
      var ft = document.createElement("div");
      ft.className = "rm-foot";
      ft.innerHTML = '<a class="rm-pill" href="' + PREORDER.url + '"><span class="rm-p1">' + PREORDER.line1 + '</span><span class="rm-p2">' + PREORDER.line2 + "</span></a>";
      d.appendChild(ft);
    }
  }
  /* dim the page while the menu is open: a plain layer that fades in and out, nothing that moves */
  function syncDim() {
    var d = document.querySelector(".rova-menu-drawer");
    var dim = document.getElementById("rova-menu-dim");
    if (!dim) { dim = document.createElement("div"); dim.id = "rova-menu-dim"; dim.setAttribute("aria-hidden", "true"); document.body.insertBefore(dim, document.body.firstChild); }
    dim.classList.toggle("on", !!(d && d.classList.contains("is-open")));
  }
  function watchMenu() {
    var watching = false;
    function watchDrawer() {
      var d = document.querySelector(".rova-menu-drawer");
      if (watching || !d || !window.MutationObserver) return;
      new MutationObserver(syncDim).observe(d, { attributes: true, attributeFilter: ["class"] });
      watching = true;
    }
    styleMenu(); syncDim(); watchDrawer(); watchMenus();
    /* coming back with the browser's Back button can restore an old state: re-check it */
    window.addEventListener("pageshow", syncDim);
    /* the menu script can redraw the drawer; put the extras back if they go missing */
    var tries = 0, t = setInterval(function () { styleMenu(); watchDrawer(); if (++tries > 20) clearInterval(t); }, 500);
    document.addEventListener("click", function (e) { if (e.target.closest && e.target.closest(".rova-menu-toggle")) { styleMenu(); patchMenus(); } }, true);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { build(); watchMenu(); }); else { build(); watchMenu(); }
})();